class UnAuthorizedError extends Error {
   constructor() {
      super('You are not authorized to make this call')
   }
}

export { UnAuthorizedError }
